import { useEffect, useRef } from "react";
import { TABBY_PK, TABBY_MC, loadTabbyScript } from "@/lib/tabby";

/* سنيبت Tabby الرسمي لصفحات المنتج والسلة (tabby-promo.js) —
   Tabby نفسها تعرض الخطط وقيمة الدفعة، بلا أي حساب يدوي. يعاد التهيئة عند تغير السعر. */
let _seq = 0;
export default function TabbyPromo({ price, lang, source = "cart", className = "mt-2" }) {
  const idRef = useRef(`tabby-promo-slot-${++_seq}`);
  useEffect(() => {
    const p = Number(price);
    if (!TABBY_PK || !TABBY_MC || !(p > 0)) return undefined;
    let on = true;
    loadTabbyScript("https://checkout.tabby.ai/tabby-promo.js").then(() => {
      if (!on || !window.TabbyPromo) return;
      const box = document.getElementById(idRef.current);
      if (!box) return;
      box.innerHTML = "";
      try {
        new window.TabbyPromo({
          selector: `#${idRef.current}`,
          currency: "SAR",
          price: p.toFixed(2),
          lang: lang === "ar" ? "ar" : "en",
          source: source === "product" ? "product" : "cart",
          publicKey: TABBY_PK,
          merchantCode: TABBY_MC,
        });
      } catch { /* السنيبت تحسيني — لا يكسر الصفحة */ }
    });
    return () => { on = false; };
  }, [price, lang, source]);
  if (!TABBY_PK || !TABBY_MC || !(Number(price) > 0)) return null;
  return <div id={idRef.current} dir={lang === "ar" ? "rtl" : "ltr"}
              data-testid="tabby-promo-snippet" data-price={Number(price).toFixed(2)}
              className={className} />;
}
